var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DownloadMediaFileMessage, DownloadTextFileMessage } from "../../../messages/media";
import { scriptService } from "../services/ScriptService";
import { AskOkMessage } from "flavr-common";
export class ScriptFileManager {
    static download(filename, fileId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!scriptService.context) {
                    throw new Error(`Context for scripts isn't defined`);
                }
                yield scriptService.context.connection.askByMessageType(new DownloadMediaFileMessage(fileId, filename), AskOkMessage);
                return true;
            }
            catch (error) {
                console.error(error);
                return false;
            }
        });
    }
    static downloadText(filename, text) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!scriptService.context) {
                    throw new Error(`Context for scripts isn't defined`);
                }
                yield scriptService.context.connection.askByMessageType(new DownloadTextFileMessage(filename, text), AskOkMessage);
                return true;
            }
            catch (error) {
                console.error(error);
                return false;
            }
        });
    }
}
